import { Component, ChangeDetectionStrategy } from '@angular/core';

@Component({
    changeDetection: ChangeDetectionStrategy.OnPush,
    selector: 'calendar-container',
    templateUrl: './calendar.component.html'
})
export class CalendarComponent {}
